<button
  mat-icon-button
  [matMenuTriggerFor]="notificationMenu"
  (click)="onOpenMenu($event)"
>
  <img src="assets/Notifications.png" alt="Filter" class="w-6 h-6 ml-2" />
  <span
    *ngIf="unreadCount > 0"
    class="absolute -top-[2px] -right-1 inline-flex items-center justify-center w-4 h-4 text-sm font-bold bg-red-light text-red rounded-full"
  >
    {{ unreadCount }}
  </span>
</button>

<mat-menu
  #notificationMenu="matMenu"
  class="bg-white font-qq custom-menu"
  style="border-radius: 1rem; box-shadow: 0px 4px 24px 0px #3030304a"
>
  <div class="px-8 py-4 border-b-2">
    <h3 (click)="$event.stopPropagation()" class="m-0">All Notifications</h3>
    <!-- Prevent menu close on clicking header -->
  </div>

  <div
    *ngIf="isLoading"
    fxLayout="column"
    fxLayoutAlign="center center"
    class="centered-content"
  >
    <mat-spinner [diameter]="30"></mat-spinner>
  </div>

  <div
    *ngIf="!isLoading"
    class="px-8 py-2 border-b-2 flex flex-col md:flex-row justify-between font-medium gap-2 bordertb"
    (click)="$event.stopPropagation()"
  >
    <div
      class="hover:edit-b flex gap-8"
      style="color: #738195"
      (click)="$event.stopPropagation()"
    >
      <button
        mat-button
        class="link"
        [class.edit-b]="filterType === 'all'"
        (click)="setFilter('all', $event); $event.stopPropagation()"
      >
        All
      </button>
      <button
        mat-button
        class="link"
        [class.edit-b]="filterType === 'unread'"
        (click)="setFilter('unread', $event); $event.stopPropagation()"
      >
        Unread
      </button>
    </div>
    <div
      class="edit-b cursor-pointer flex items-center"
      (click)="markAllAsRead($event); $event.stopPropagation()"
    >
      Mark all as read
    </div>
    <div class="edit-b cursor-pointer flex items-center" (click)="markAllDelete($event); $event.stopPropagation()">All
      delete</div>
  </div>

  <!-- <div
    *ngIf="filteredNotifications.length > 0 && !isLoading; else noNotifications"
    (click)="$event.stopPropagation()"
  > -->
  <!-- <div class="px-8 py-3" *ngFor="let notification of filteredNotifications">
      <div class="flex gap-4 items-center justify-between">
        <div class="flex gap-4 items-center">
          <ng-container
            *ngIf="notification?.senderId?.profile_image; else defaultAvatar"
          >
            <img
              [src]="notification.senderId.profile_image"
              alt="Profile Image"
              class="h-10 w-10 rounded-full object-cover"
            />
          </ng-container>

          <ng-template #defaultAvatar>
            <img
              src="assets/default-avatar.png"
              alt="Default Avatar"
              class="h-10 w-10 rounded-full object-cover"
            />
          </ng-template>

          <div>
            <p
              class="font-semibold cursor-pointer"
              (click)="
                toggleMessageVisibility(notification, $event);
                $event.stopPropagation()
              "
            >
              <span
                [routerLink]="[notification.link]"
                [queryParams]="{ id: notification.id }"
                style="
                  color: #1f5bd7;
                  text-decoration: underline;
                  cursor: pointer;
                "
                (click)="closeMenu()"
              >
                {{ notification.caseNumber }} </span
              >:
              {{ notification.title }}
            </p>

            <p
              *ngIf="notification.showMessage || notification.unread === false"
              class="text-black font-medium"
            >
              {{ notification.message }}
            </p>
          </div>
        </div>
        <div>
          <span class="text-sm" style="color: #738195">
            {{ getTimeAgo(notification.createdAt) }}
          </span>
          <span
            *ngIf="notification.unread === true"
            class="ml-1 w-2 h-2 rounded-full"
            style="background-color: #1f5bd7"
          ></span>
        </div>
      </div>
    </div> -->

  <div
    *ngIf="
      hasNotifications(filteredNotifications) && !isLoading;
      else noNotifications
    "
    (click)="$event.stopPropagation()"
  >
    <div
      class="px-8 "
      *ngFor="let group of ['today', 'yesterday', 'last7Days', 'older']"
    >
      <div *ngIf="filteredNotifications[group]?.length > 0">
        <h4 class="group-heading ">
          {{ getGroupLabel(group) }}
        </h4>

        <div
          *ngFor="let notification of filteredNotifications[group]"
          class="mb-4 cursor-pointer hover:bg-gray-50 p-2 rounded transition-colors"
          (click)="onNotificationClick(notification, $event)"
        >
          <div class="flex items-center justify-between">
            <div class="flex gap-4 items-center">
              <img
                src="assets/user.png"
                alt="Default Avatar"
                class="h-10 w-10 rounded-full object-cover"
              />

              <div>
                <p class="font-semibold m-0">
                  <span
                    *ngIf="notification.caseNumber && notification.link"
                    [routerLink]="[notification.link]"
                    [queryParams]="{ id: notification.id }"
                    style="
                      color: #1f5bd7;
                      text-decoration: underline;
                      cursor: pointer;
                    "
                    (click)="onCaseNumberClick(notification, $event)"
                  >
                    {{ notification.caseNumber }} </span
                  ><span *ngIf="notification.caseNumber && notification.link">: </span>{{ notification.title }}
                </p>

                <p class="text-black font-medium m-0">
                  {{ notification.message }}
                </p>
              </div>
            </div>
            <div class="flex justify-center items-center gap-2">
              <span class="time-msg">
                {{ getTimeAgo(notification.createdAt) }}
              </span>
              <!-- class="ml-1 w-2 h-2 rounded-full"
              style="background-color: #1f5bd7" -->
              <span *ngIf="notification.unread === true" class="flex justify-center items-center">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="15"
                  height="15"
                  viewBox="0 0 15 15"
                  fill="none"
                >
                  <path
                    d="M15 7.5C15 11.6421 11.6421 15 7.5 15C3.35786 15 0 11.6421 0 7.5C0 3.35786 3.35786 0 7.5 0C11.6421 0 15 3.35786 15 7.5Z"
                    fill="#1F5BD7"
                  />
                </svg>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- </div> -->

  <ng-template #noNotifications>
    <div
      class="px-8 py-5 text-center"
      style="color: #738195"
      (click)="$event.stopPropagation()"
    >
      <p (click)="$event.stopPropagation()">No notifications available.</p>
    </div>
  </ng-template>
</mat-menu>
